import { ModalDialog, ModalDialogProps, StyledDialog, Trigger } from '@zillow/constellation';
import React from 'react';
import styled, { keyframes } from 'styled-components';

const slideFromRightKeyframes = keyframes`
  0% {
    transform: translateX(100%); /* Start off-screen to the right */
  }
  100% {
    transform: translateX(0); /* End at its normal position */
  }
`;

const SlidingModalDialog = styled(ModalDialog)`
  ${StyledDialog} {
    animation: ${slideFromRightKeyframes} 300ms ease-in-out;
    transform: translateX(0);
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
  }
`;

interface DrawerConstellationProps extends ModalDialogProps {
  triggerElement: React.ReactNode;
  children?: React.ReactNode;
}
/* This component is a composition of Trigger and a specialized ModelDialog.
 * The animation only occurs when the drawer is opened.
 * I borrowed the idea from the Premier Agent team.
 * https://itx.pages.zgtools.net/premier-agent/sfo/zrs-premier-agent/main/styleguide/#drawer
 * https://gitlab.zgtools.net/itx/premier-agent/sfo/zrs-premier-agent/-/blob/main/src/components/Drawer/Drawer.jsx
 */
export const DrawerConstellation: React.FC<DrawerConstellationProps> = ({ triggerElement, ...modalDialogProps }) => {
  return <Trigger triggered={<SlidingModalDialog {...modalDialogProps} />}>{triggerElement}</Trigger>;
};
